import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDiscussionsRequestFailure(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.request.isFailure : false;
    },
    isRetrieveDiscussionsRequestPending(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.request.isPending : false;
    },
    isRetrieveDiscussionsRequestSuccess(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.request.isSuccessful : false;
    },
    getDiscussions(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.discussions : [];
    },
    getDiscussionsCurrentPage(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.page : 0;
    },
    canLoadMoreDiscussions(project) {
      const result = getState().find(
        (result) => result.project.uuid === project.uuid,
      );

      return result ? result.canLoadMore : true;
    },
  };
}

export { createSelector };
